import { render, staticRenderFns } from "./complaintRegister.vue?vue&type=template&id=19f46dc2&scoped=true"
import script from "./complaintRegister.vue?vue&type=script&lang=js"
export * from "./complaintRegister.vue?vue&type=script&lang=js"
import style0 from "./complaintRegister.vue?vue&type=style&index=0&id=19f46dc2&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19f46dc2",
  null
  
)

export default component.exports